export const flipStyle = {
  padding: '15px',
  width: '100%',
  height: '100%',
} as React.CSSProperties;

export const secondFlipImageStyle = (
  isMobile?: boolean,
): React.CSSProperties => ({
  width: isMobile ? '100%' : '65%',
  height: '100%',
  display: 'block',
  float: 'left',
  overflow: 'hidden',
});

export const secondFlipTopText = {
  textAlign: 'right',
  height: 'inherit',
} as React.CSSProperties;

export const breakWordStyle = (isMobile?: boolean): React.CSSProperties => ({
  wordWrap: 'break-word',
  width: isMobile ? '100%' : 'auto',
});
